import { render } from "./SellerSwapWorkspaceView.vue?vue&type=template&id=0da81a61&scoped=true"
import script from "./SellerSwapWorkspaceView.vue?vue&type=script&lang=js"
export * from "./SellerSwapWorkspaceView.vue?vue&type=script&lang=js"

import "./SellerSwapWorkspaceView.vue?vue&type=style&index=0&id=0da81a61&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da81a61"]])

export default __exports__